export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;

export const KEY = '95e74a48-befa-442a-8e68-7b0c06078f5a';
export const MODAL_CLOSE_SEC = 2.5;
